//registers interceptor
function loadingInterceptorConfig($httpProvider) {
    "ngInject";
    $httpProvider.interceptors.push('loadingInterceptor');
}
export default loadingInterceptorConfig;


// WEBPACK FOOTER //
// ./client/app/app.config.loadingInterceptor.js